import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as PatientActions from '../state/patient.actions';
import { selectLogoutData } from '../state/patient.selectors';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { WINDOW } from 'Shared/app/core/services/window.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WFP_ROUTES } from 'projects/patient/src/app/constants/routes';

@Component({
  selector: 'wfp-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false
})
export class LogoutComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);
  readonly #store = inject(Store);
  readonly #router = inject(Router);
  readonly #authenticationService = inject(AuthenticationService);
  readonly #WINDOW = inject<Window>(WINDOW);

  ngOnInit() {
    this.#store
      .select(selectLogoutData)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((logoutData) => {
        if (!logoutData.isLoggedIn) {
          this.#router.navigateByUrl(WFP_ROUTES.LOGIN);
          return;
        }
        if (logoutData.isSsoLogin) {
          this.#authenticationService.logoutSSO().subscribe({
            next: (signOutData) => {
              this.#store.dispatch(PatientActions.logoutSuccess());
              if (signOutData?.url) {
                setTimeout(() => {
                  this.#WINDOW.location.href = signOutData.url;
                }, 50);
              } else {
                //Fallback if there's no url to send the user
                this.#router.navigateByUrl(WFP_ROUTES.LOGIN);
              }
            },
            error: () => {
              this.#store.dispatch(PatientActions.logoutFailure());
            }
          });
        } else {
          this.#store.dispatch(PatientActions.logout());
        }
      });
  }
}
